import { message } from 'src/antd';
import { T } from '@transifex/react';
import { create } from 'zustand';
import { mountStoreDevtool } from 'simple-zustand-devtools';
import React from 'react';
import { apiNotification } from '../../../../api/notifications';
import { APIError } from '../../../../api/consts/error';
import { getCookie } from '../../../../utils/cookies';
import {
  smsCodeCookie,
  smsServiceMode,
  smsServicePhoneNumber,
} from '../../../../consts/cookie-consts';

export type TSubscription = {
  id: string;
  daysBefore: number;
};

export type TNotificationMode = 'sms' | 'email';

type TSummaryData = {
  phoneNumber?: string;
  email?: string;
  mode: TNotificationMode;
};

type TViewSmsServiceStore = {
  mode: TNotificationMode;
  context: { propertyId: string; token: string };
  data: {
    verificationCode: string;
    subscriptions: TSubscription[];
    other: TSummaryData;
  };
  setVerificationCode: (code: string, d: TSummaryData) => void;
  updateSubscriptions: (subscriptions: TSubscription[]) => void;
  initStore: (
    d: Pick<TViewSmsServiceStore, 'context'>,
    mode: TNotificationMode
  ) => void;
  reset: () => void;
};

export const useSmsServiceStore = create<TViewSmsServiceStore>()(
  (set, get) => ({
    mode: 'sms',
    data: {
      verificationCode: getCookie(smsCodeCookie) || '',
      subscriptions: [],
      other: {
        mode: (getCookie(smsServiceMode) as TNotificationMode) || 'sms',
        phoneNumber: getCookie(smsServicePhoneNumber) || '',
        email: '',
      },
    },
    setVerificationCode: async (c, summaryData) => {
      const { context } = get();
      // get the containers.
      try {
        const { data }: $TSFixMe =
          await apiNotification.callGetAllNotificationContainers({
            propertyId: context.propertyId,
            token: context.token,
            verificationId: c,
          });
        set({
          data: {
            verificationCode: c,
            subscriptions:
              data?.map(
                ({ container, days_before }: $TSFixMe): TSubscription => ({
                  id: container.id,
                  daysBefore: days_before,
                })
              ) || [],
            other: summaryData ||
              get().data?.other || {
                mode: get().mode,
                phoneNumber: '',
                email: '',
              },
          },
        });
      } catch (e: unknown) {
        const error: APIError = e as APIError;
        if (!error.opts?.ERROR_MESSAGE_HANDLED)
          message.error(<T _str="Error occured" />);
      }
    },
    updateSubscriptions: (c) => {
      set({
        data: {
          verificationCode: get().data.verificationCode,
          subscriptions: c,
          other: get().data.other,
        },
      });
    },
    context: { propertyId: '', token: '' },
    initStore: (v, mode) => {
      set({
        context: v.context,
        mode,
      });
    },
    reset: () => {
      set({
        data: {
          verificationCode: '',
          subscriptions: [],
          other: {
            mode: get().mode,
            phoneNumber: '',
            email: '',
          },
        },
      });
    },
  })
);

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Store', useSmsServiceStore);
}
